import { render, staticRenderFns } from "./TYKSStart.vue?vue&type=template&id=b8f4d1de&scoped=true"
import script from "./TYKSStart.vue?vue&type=script&lang=js"
export * from "./TYKSStart.vue?vue&type=script&lang=js"
import style0 from "./TYKSStart.vue?vue&type=style&index=0&id=b8f4d1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f4d1de",
  null
  
)

export default component.exports